import request from '@/utils/request'

// 删除权限分配信息
export function deleteUser(query) {
  return request({
    url: '/index/SystemConfig/deleteUser',
    method: 'get',
    params: query
  })
}

// 操作记录列表
export function getUserActionLogList(query) {
  return request({
    url: '/index/SystemConfig/getUserActionLogList',
    method: 'get',
    params: query
  })
}

// 权限分配列表
export function getUserList(query) {
  return request({
    url: '/index/SystemConfig/getUserList',
    method: 'get',
    params: query
  })
}

// 获取 权限 选项
export function getPowerOption(query) {
  return request({
    url: '/index/SystemConfig/getPowerOption',
    method: 'get',
    params: query
  })
}

// 新增权限分配
export function addPlotAdmin(data) {
  return request({
    url: '/index/SystemConfig/addPlotAdmin',
    method: 'post',
    data
  })
}

// 新增 报警接收
export function addWarningConfig(data) {
    return request({
      url: '/index/SystemConfig/addWarningConfig',
      method: 'post',
      data
    })
}

// 编辑报警接收
export function editWarningConfig(query) {
  return request({
    url: '/index/SystemConfig/editWarningConfig',
    method: 'get',
    params: query
  })
}

// 删除报警接收
export function deleteWarningConfig(query) {
  return request({
    url: '/index/SystemConfig/deleteWarningConfig',
    method: 'get',
    params: query
  })
}

// 更新报警接收
export function updateWarningConfig(data) {
  return request({
    url: '/index/SystemConfig/updateWarningConfig',
    method: 'post',
    data
  })
}

// 获取报警限值列表
export function getEnvironmentList(query) {
  return request({
    url: '/index/SystemConfig/getEnvironmentList',
    method: 'get',
    params: query
  })
}

// 编辑报警限值
export function editEnvironment(query) {
  return request({
    url: '/index/SystemConfig/editEnvironment',
    method: 'get',
    params: query
  })
}

// 更新报警限值
export function updateEnvironment(data) {
  return request({
    url: '/index/SystemConfig/updateEnvironment',
    method: 'post',
    data
  })
}

// 获取报警接收列表
export function getWarningConfigList(query) {
  return request({
    url: '/index/SystemConfig/getWarningConfigList',
    method: 'get',
    params: query
  })
}

// 获取 用户 列表
export function getUserLists(query) {
  return request({
    url: '/common/index/getUserList',
    method: 'get',
    params: query
  })
}

// 删除 地块 信息
export function deletePlot(query) {
  return request({
    url: '/index/SystemConfig/deletePlot',
    method: 'get',
    params: query
  })
}

// 删除 基地 信息
export function deleteFound(query) {
  return request({
    url: '/index/SystemConfig/deleteFound',
    method: 'get',
    params: query
  })
}

// 编辑 地块 信息
export function editPlot(query) {
  return request({
    url: '/index/SystemConfig/editPlot',
    method: 'get',
    params: query
  })
}

// 编辑 基地 信息
export function editFound(query) {
  return request({
    url: '/index/SystemConfig/editFound',
    method: 'get',
    params: query
  })
}

// 设备 绑定 地块
export function DeviceToPlot(data) {
    return request({
      url: '/index/SystemConfig/DeviceToPlot',
      method: 'post',
      data
    })
}

// 获取 设备 列表
export function getDeviceList(query) {
  return request({
    url: '/index/systemConfig/deviceList',
    method: 'get',
    params: query
  })
}

// 获取 设备 列表
export function deviceDelete(data) {
  return request({
    url: '/index/systemConfig/deviceDelete',
    method: 'delete',
    data
  })
}

// 新增 设备
export function deviceSave(data) {
  return request({
    url: '/index/systemConfig/deviceSave',
    method: 'post',
    data
  })
}

// 查看 设备信息
export function deviceRead(query) {
  return request({
    url: '/index/systemConfig/deviceRead',
    method: 'get',
    params: query
  })
}

// 修改 设备
export function deviceUpdate(data) {
  return request({
    url: '/index/systemConfig/deviceUpdate',
    method: 'PUT',
    data
  })
}

// 获取 地块 列表
export function getPlotList(query) {
  return request({
    url: '/index/SystemConfig/getPlotList',
    method: 'get',
    params: query
  })
}

// 获取 基地 列表
export function getFoundList(query) {
  return request({
    url: '/index/SystemConfig/getFoundList',
    method: 'get',
    params: query
  })
}

// 获取 基地管理员 列表
export function getFoundAdminList(query) {
  return request({
    url: 'index/SystemConfig/getFoundAdminList',
    method: 'get',
    params: query
  })
}

// 新增 地块
export function addPlot(data) {
    return request({
      url: '/index/SystemConfig/addPlot',
      method: 'post',
      data
    })
}

// 新增 地块
export function updatePlot(data) {
    return request({
      url: '/index/SystemConfig/updatePlot',
      method: 'post',
      data
    })
}

// 新增 基地
export function addFound(data) {
    return request({
      url: '/index/SystemConfig/addFound',
      method: 'post',
      data
    })
}

// 更新 基地
export function updateFound(data) {
    return request({
      url: '/index/SystemConfig/updateFound',
      method: 'post',
      data
    })
}

// 新增 基地管理员
export function addFoundAdmin(data) {
    return request({
      url: '/index/SystemConfig/addFoundAdmin',
      method: 'post',
      data
    })
}

// 编辑基地管理员信息
export function editFoundAdmin(query) {
  return request({
    url: '/index/SystemConfig/editFoundAdmin',
    method: 'get',
    params: query
  })
}

// 更新 基地管理员
export function updateFoundAdmin(data) {
    return request({
      url: '/index/SystemConfig/updateFoundAdmin',
      method: 'post',
      data
    })
}

// 获取基地选项
export function getFoundOption(query) {
  return request({
    url: '/index/index/getFoundOption',
    method: 'get',
    params: query
  })
}

// 获取某基地下地块列表
export function getFoundPlotList(query) {
  return request({
    url: '/index/index/getFoundPlotList',
    method: 'get',
    params: query
  })
}

// 获取 土壤类型 选项
export function getSoilTypeOption(query) {
  return request({
    url: '/common/index/getSoilTypeOption',
    method: 'get',
    params: query
  })
}

// 获取 地块类型 选项
export function getPlotTypeOption(query) {
  return request({
    url: '/common/index/getPlotTypeOption',
    method: 'get',
    params: query
  })
}

// 获取 地块用途 选项
export function getPlotUseOption(query) {
  return request({
    url: '/common/index/getPlotUseOption',
    method: 'get',
    params: query
  })
}

// 根据绑定的设备返回显示的栏目
export function displayMenuByDevice(query) {
  return request({
    url: '/index/systemConfig/displayMenuByDevice',
    method: 'get',
    params: query
  })
}

// 获取虫情光诱测报灯的链接
export function readDevice6Link(query) {
  return request({
    url: '/index/systemConfig/readDevice6Link',
    method: 'get',
    params: query
  })
}

const path = process.env.VUE_APP_BASE_API

const uploadpath = process.env.VUE_APP_BASE_API + '/common/index/uploadImg'

export { path, uploadpath }
